import apiTCEComunica from '../infra/apiTCEComunica'

const ControleAcessoService = {
    ConsultaPerfisGerenciarPerfis: async (idOrgao) => {
        return await apiTCEComunica({
            method: 'get',
            url: '/api/v1/ControleAcesso/perfis/gerenciar-perfis',
            headers: {
                'idOrgao': idOrgao
            }
        })
    },
    ConsultaPerfisManutencaoAcessos: async (idOrgao) => {
        return await apiTCEComunica({
            method: 'get',
            url: '/api/v1/ControleAcesso/perfis/manutencao-acessos',
            headers: {
                'idOrgao': idOrgao
            }
        })
    },
    ConsultaPorId: async (id, ehRegistroSolicitacaoGestor) => {
        return await apiTCEComunica({
            method: 'get',
            url: '/api/v1/ControleAcesso/id/' + id + '',
            headers: {
                'ehRegistroSolicitacaoGestor': ehRegistroSolicitacaoGestor
            }
        })
    },
    ConsultaUsuario: async (termo, tipoConsulta, pagina, qtdePagina, idOrgao) => {
        return await apiTCEComunica({
            method: 'get',
            url: '/api/v1/ControleAcesso/tipoConsulta/' + tipoConsulta + '/pagina/' + pagina + '/qtdePagina/' + qtdePagina + '',
            headers: {
                'termo': termo,
                'idOrgao': idOrgao
            }
        })
    },
    ConsultaOrgaosUsuario: async () => {
        return await apiTCEComunica.get(`/api/v1/ControleAcesso/usuario/orgaos`)
    },
    ConsultaOrgaosUsuarioInformado: async (idUsuario) => {
        return await apiTCEComunica.get(`/api/v1/ControleAcesso/usuario/informado/${idUsuario}/orgaos`)
    },
    Salva: async (usuario, idOrgao) => {
        return await apiTCEComunica({
            method: 'post',
            url: '/api/v1/ControleAcesso/salve',
            headers: {
                'idOrgao': idOrgao
            },
            data: usuario
        })
    },
    Revogar: async (id) => {
        return await apiTCEComunica.delete(`/api/v1/ControleAcesso/revoga/id/${id}`)
    },
    ExportaCsv: async (termo, tipoConsulta, idOrgao) => {
        return await apiTCEComunica({
            method: 'get',
            url: '/api/v1/ControleAcesso/exporta/csv/tipoConsulta/' + tipoConsulta + '',
            headers: {
                'termo': termo,
                'idOrgao': idOrgao
            }
        })
    }
}

export default ControleAcessoService 